import { takeLatest } from 'redux-saga/effects';
import { FLYOUT_CLICKED, ON_VALID_VIN_DATA, SELECTION_METHOD_CHANGED, ON_GENERIC_VEHICLE_LOAD, ON_VEHICLE_RESOLVED_ON_LOAD } from '../actions';
import { flyoutClickedAction } from './flyoutClicked';
import manualSelectClickedAction from './manualSelectClicked';
import { vinDecodeAction } from './vinDecode';
import { genericVehicleLoadSaga } from './genericVehicleLoadSaga';
import { vehicleResolvedOnLoadSaga } from './vehicleResolvedOnLoadSaga';
export const vehicleInfoRootSaga = [
    takeLatest(ON_VEHICLE_RESOLVED_ON_LOAD, vehicleResolvedOnLoadSaga),
    takeLatest(ON_VALID_VIN_DATA, vinDecodeAction),
    takeLatest(FLYOUT_CLICKED, flyoutClickedAction),
    takeLatest(SELECTION_METHOD_CHANGED, manualSelectClickedAction),
    takeLatest(ON_GENERIC_VEHICLE_LOAD, genericVehicleLoadSaga)
];
//# sourceMappingURL=vehicleInfoRootSaga.js.map